import React from 'react';
import { isOtsEnabled } from 'data/FeatureCheck';

function withOtsEnabled(Component) {
	return (props) => <Component { ...props } otsEnabled={isOtsEnabled()} />
}

export default withOtsEnabled;



// WEBPACK FOOTER //
// ./src/react/containers/helper/withOtsEnabled.jsx